import { render, staticRenderFns } from "./order-view-delivery.vue?vue&type=template&id=5c7b9aa4&scoped=true&"
import script from "./order-view-delivery.vue?vue&type=script&lang=js&"
export * from "./order-view-delivery.vue?vue&type=script&lang=js&"
import style0 from "./order-view-delivery.vue?vue&type=style&index=0&id=5c7b9aa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7b9aa4",
  null
  
)

export default component.exports